import logoPng from "../assets/logo.png";

interface HomeSectionProps {
  navigateTo: (pageId: string) => void;
}

export function HomeSection({ navigateTo }: HomeSectionProps) {
  return (
    <div id="home" className="page-section flex flex-col grow bg-petroleo">
      <section className="hero-bg min-h-screen flex items-center justify-center text-center px-4 relative pt-nav grow">
        <div className="max-w-4xl z-10 flex flex-col items-center">
          <img
            src={logoPng}
            alt="Logo Hórus 147"
            className="w-48 h-48 md:w-56 md:h-56 object-cover rounded-full  shadow-2xl mb-8 bg-petroleo transform transition hover:scale-105 duration-300"
          />

          <p className="text-dourado font-medium tracking-[0.2em] uppercase mb-4 text-lg md:text-xl">
            Augusta e Respeitável Loja Simbólica
          </p>
          <h1 className="text-5xl sm:text-6xl md:text-8xl font-bold text-white mb-6 uppercase tracking-widest drop-shadow-lg">
            Loja Hórus
            <br/>
            <span className="text-dourado">Nº 147</span>
          </h1>
          <div className="w-72 border-b-2 border-dourado mx-auto mb-8 shadow-sm"></div>
          <p className="text-gray-300 text-xl sm:text-2xl md:text-3xl italic font-light mb-12 font-titulo">
            "Liberdade, Igualdade, Fraternidade."
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button
              onClick={() => navigateTo("quem-somos")}
              className="bg-dourado text-petroleo px-10 py-4 rounded font-bold uppercase tracking-widest hover:bg-yellow-500 transition shadow-lg text-sm"
            >
              Conhecer a Oficina
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
